import * as React from 'react';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

function TextField(props: TextFieldProps, ref: React.Ref<HTMLInputElement>) {
  return <MuiTextField {...props} inputRef={ref} />;
}

export default React.forwardRef(TextField);
